export default {
    documents: {
        date: 'Date',
        download: 'Download',
        no_data: 'No documents',
        review: 'Review',
        documentRequestWelcome: 'Welcome, %(pplname)s!',
        documentRequest: 'Require to upload next documents:',
        requestEmpty: 'No more documents to upload',
        types: {
            kadryppldoc: 'Recruitment document',
            passport: 'Passport copy',
            inn: 'ИНН copy',
            snils: 'СНИЛС copy',
            diploma: 'Diploma copy',
            family_cert: 'Family certificate copy',
            militaryid: 'Military id copy',
            privil_cert: 'Privilage cerificate copy',
            emplhistory: 'Employment history copy',
            bank_rekv: 'Bank account copy',
            opd: 'PDP approval',
        },
        documentRequestSend: 'Send documents',
        welcomeSuccess: 'Documents successfuly sended',
        opdButton: 'Sign approve for PDP',
        cancelOpd: 'Cancel approval',
        changeOpd: 'Change info',
        opdModalTitle: 'Presonal data processing approve',
        openVcv: 'Go to interview view',
    },
};
